export default __webpack_public_path__ + "static/media/doc.de7674ac.svg";